import React, {
  Fragment, useContext, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DataTable from '../../../../components/DataTable';
import Title from '../../../../components/Title';
import ButtonLink from '../../../../components/ButtonLink';
import { MessageContext } from '../../../../providers/MessageProvider';
import { DispatchDialogContext } from '../../../../providers/DialogProvider/DialogContext';
import config from '../../config';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const urlTab = {
  nuevo: `${config.PATH}/push/nuevo`,
}

const uri = '/service/v1/notifications/list';

const params = {
  sort: 'id_push_notification|desc',
};

function Popup() {
  const messages = useContext(MessageContext);
  const dialog = useContext(DispatchDialogContext);

  useEffect(() => {
    if (messages.length > 0) {
      dialog({
        type: messages[0].type,
        content: messages[0].message,
      });
    }
  }, [messages]);

  const allGroup = attr => (
    <>{attr ? 'Si' : 'No' }</>
  );

  const FormatedDate = (attr, row) => (
    // attr ? (
    //   <Fragment>{moment(row.scheduled_datetime).format('DD-MM-YYYY hh:mm A')}</Fragment>
    // ) : (<Fragment>{moment(row.created_date).format('DD-MM-YYYY hh:mm A')}</Fragment>);
    attr ? (
      <Fragment>{row.scheduled_datetime}</Fragment>
    ) : (<Fragment>{row.created_date}</Fragment>)
  );

  const tableHeaders = [
    {
      name: 'title',
      label: 'Título',
    },
    {
      name: 'content_body',
      label: 'Mensaje',
    },
    {
      name: 'type',
      label: 'Tipo',
      width: 112,
    },
    {
      name: 'all_group',
      label: 'Todos las empresas',
      component: allGroup,
      width: 112,
    },
    {
      name: 'company_name',
      label: 'Empresa',
    },
    {
      name: 'discount_provider',
      label: 'Comercio',
    },
    {
      name: 'discount_disclaimer',
      label: 'Beneficio',
    },
    {
      name: 'scheduled',
      label: 'Fecha de envío',
      component: FormatedDate,
      width: 112,
    },
  ];

  return (
    <Fragment>
      <Title variant="h5" component="h2">Push Notifications Programados</Title>
      <ButtonLink color="primary" square href={urlTab.nuevo}>Nuevo</ButtonLink>
      <DataTable uri={uri} params={params} headers={tableHeaders} />
    </Fragment>
  );
}

Popup.propTypes = propTypes;

export default Popup;
